export const getCookieConsent = state => state.session.cookies.cookieConsent.allowCookies;
